import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import creatableSelectStyles from "../constants/creatable-select-styles";
import {
  MERGE_FIELD_MAPPING,
  SQUARE_MERGE_FIELD,
} from "../constants/proptypes";

const SquareMergeFieldSelect = ({
  squareMergeFields,
  mergeFieldMapping,
  index,
  onChange = () => {},
  isDisabled = false,
  invalid = false,
}) => {
  const squareMergeFieldToOption = (squareMergeField) => ({
    value: squareMergeField,
    label: Object.values(squareMergeFields[squareMergeField] || {}).join(),
    ...squareMergeFields[squareMergeField],
  });

  const squareMergeFieldOptions = Object.keys(squareMergeFields).map(
    squareMergeFieldToOption
  );

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <>
          <div>
            <strong>{option.text}</strong>
          </div>
          <div>{option.description}</div>
        </>
      );
    }

    return option.text;
  };

  return (
    <Select
      isClearable
      isSearchable
      isDisabled={isDisabled}
      styles={creatableSelectStyles({ invalid })}
      className="square-merge-field"
      aria-label={`Square Merge Field ${index}`}
      options={squareMergeFieldOptions}
      value={squareMergeFieldToOption(mergeFieldMapping.squareField)}
      onChange={onChange}
      formatOptionLabel={formatOptionLabel}
    />
  );
};

SquareMergeFieldSelect.propTypes = {
  squareMergeFields: SQUARE_MERGE_FIELD.isRequired,
  mergeFieldMapping: MERGE_FIELD_MAPPING.isRequired,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  invalid: PropTypes.bool,
  index: PropTypes.number.isRequired,
};

export default SquareMergeFieldSelect;
